import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

export const postListarBannerUsuarioLogado = async (params: {
  codigoRegional365: string;
  codigoEmpresaVendas365: string;
  authToken?: string;
}): Promise<any> => {
  const url = "/api/banner/ListarBannerPorUsuarioLogadoSellIt";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(
    url,
    parameters,
    authToken ? config : {}
  );
  return response?.data;
};
